import { createTheme } from "@mui/material/styles";
import { brand } from "./brandTokens";

/**
 * MUI theme: buttons using color="primary" / variant="contained|outlined|text"
 * pick up logo colors from brand.json. Inline sx with hardcoded hex still overrides.
 */
export const appTheme = createTheme({
  palette: {
    primary: {
      main: brand.primary,
      light: brand.facet,
      dark: brand.primaryHover,
      contrastText: "#ffffff",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 8,
        },
        containedPrimary: {
          backgroundColor: brand.primary,
          "&:hover": {
            backgroundColor: brand.primaryHover,
          },
          "&:active": {
            backgroundColor: brand.primaryActive,
          },
        },
        outlinedPrimary: {
          borderWidth: "1.5px",
          borderColor: brand.primary,
          color: brand.primary,
          "&:hover": {
            borderColor: brand.primaryHover,
            color: brand.primaryHover,
            backgroundColor: brand.mist,
          },
        },
        textPrimary: {
          color: brand.primary,
          "&:hover": {
            backgroundColor: "rgba(139, 92, 246, 0.08)",
          },
        },
      },
    },
  },
});
